import { AuditTrailAction } from './AuditTrailAction';
import { convertISODateToEventDate } from '@sonar-software/sonar-ts-lib';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
export const dateColumn = {
    dataIndex: 'auditDate',
    ellipsis: true,
    fixed: true,
    key: 'auditDate',
    render: (auditDate) => convertISODateToEventDate(auditDate),
    title: COPY_SPECIFIC.DATE,
    width: 160
};
export const actionColumn = {
    dataIndex: 'action',
    ellipsis: true,
    key: 'action',
    render: (action, record) => React.createElement(AuditTrailAction, { action: action, classification: record.classification }),
    title: COPY_SPECIFIC.ACTION,
    width: 150
};
export const userColumn = {
    dataIndex: 'user',
    ellipsis: true,
    key: 'user',
    title: COPY_SPECIFIC.USER,
    width: 120
};
export const sourceColumn = {
    dataIndex: 'sourceNamePrefix',
    ellipsis: true,
    key: 'sourceNamePrefix',
    title: COPY_SPECIFIC.SOURCE_NAMESPACE_PREFIX,
    width: 220
};
export const sectionColumn = {
    dataIndex: 'section',
    ellipsis: true,
    key: 'section',
    title: COPY_SPECIFIC.SECTION,
    width: 120
};
export const delegateColumn = {
    dataIndex: 'delegateUser',
    ellipsis: true,
    key: 'delegateUser',
    title: COPY_SPECIFIC.DELEGATE_USER,
    width: 120
};
export function getColumns() {
    return [
        dateColumn,
        actionColumn,
        userColumn,
        sectionColumn,
        delegateColumn,
        sourceColumn
    ];
}
